var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 1.25A1.75 1.75 0 0 0 .25 3v3h1v7c0 .966.783 1.75 1.75 1.75h4v-1.5H3a.25.25 0 0 1-.25-.25V6h10.5v2h1.5V6h1V3A1.75 1.75 0 0 0 14 1.25zM14.25 4.5V3a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v1.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6.585 3.531a.75.75 0 0 1-.117 1.055l-2.5 2a.75.75 0 0 1-.937 0l-2.5-2a.75.75 0 0 1 .937-1.172l1.282 1.026V10.5a.75.75 0 0 1 1.5 0v2.94l1.28-1.026a.75.75 0 0 1 1.055.117"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export default ForwardRef;